import React, { FC } from "react";

import CampaignBuilderForm from "../../components/redesign/modules/CampaignBuilderForm";
import { CAMPAIGN_PLAY_TYPE } from "../../constants/campaignPlayTypes";

const CustomCampaignCreatePageRedesign: FC = () => (
  <CampaignBuilderForm mode="campaign" campaignPlayType={CAMPAIGN_PLAY_TYPE.CUSTOM} />
);

export default CustomCampaignCreatePageRedesign;
